<!-- 采购商品模板 -->
<template>
	<div>
		<el-dialog :visible.sync="dialogVisible" title="选择库存商品"  append-to-body center  width="80%" top="2rem">
			
			<div class='components_content_box'>
				<div class="components_content_top">
					<el-form :inline="true" :model="getRequestData" class="demo-form-inline">
						<el-form-item label="通用名称">
							<el-input ref="bgmNameSearch"  v-model.trim="getRequestData.bgmName" size="mini" :maxlength="$store.state.inputLength" ></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="components_content_content">
					<el-table :data="returnData.list" height="100%" border size="mini" @row-dblclick="selectData"  style="width: 100%;">
						<el-table-column  prop="bgmName"  label="通用名称">
						</el-table-column>
						<el-table-column  prop="bgmManufacturer"  label="生产商">
						</el-table-column>
						<el-table-column  prop="bgmSpecifications"  label="规格">
						</el-table-column>
						<el-table-column  prop="bgmPlaceorigin"  label="产地">
						</el-table-column>
						<el-table-column  prop="bgfIntaxrate"  label="进项税率">
						</el-table-column>
						<el-table-column  prop="limdHighnum"  label="库存上限">
						</el-table-column>
						<el-table-column  prop="limdLownum"  label="库存下限">
						</el-table-column>
						<el-table-column  prop="rjXl"  label="日均销量">
						</el-table-column>
						<el-table-column  prop="stockNum"  label="当前库存数量">
						</el-table-column>
					</el-table>
				</div>
				<div class="components_content_bottom">
					<el-pagination
						background
						@size-change="setDataPageSize"
						@current-change="setDataPageNumber"
						:current-page="getRequestData.page"
						:page-sizes="[30,50,100,500]"
						:page-size="30"
						layout="total, sizes, prev, pager, next, jumper"
						:total="returnData.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'purchaseGoodsTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				"bgmName": "",
				"coId":'',
				"end": '',
				"opmId": '',
				"ormId": '',
				page:1,
				rows:30,
				"pspmBuycus": '',
				"pspmEdate": '',
				"pspmSdate": '',
				"start": ''
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {
		selectData(row, column, event){
			this.$emit('selectDataAction',row);
			this.dialogVisible = false
		},
		openBox(){
			this.getDataList()
			this.dialogVisible = true
		},
		
		closeBox(){
			this.dialogVisible = false
		},
		
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getPurchaseGoods(this.getRequestData)
			
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
